// extracted by mini-css-extract-plugin
export default {"container":"_CFuR","cardWrapper":"zvL7U","card":"M0wo0"};